import React, { useState, useEffect } from "react";
import Button from "../../buttons/Button";
import { useLanguageContext } from "../../../context/languageContext";
import enUS from "../../../data/en-US";
import { fakedb } from "../../../data/fakedb";
import Card06 from "../../cards/Card06";

const NFTShowcaseSection
= () => {
    const { language } = useLanguageContext();
    const [ data, setData ] = useState();
    const info = {
        'en-US': enUS
    }
    useEffect(() => {
        setData(info[language].homepage.nft_showcase)
    })

    return (

        <div className="showcase-section-wrapper font-face-poppins mt-5">
            <div className="themesflat-container">
                <div className="showcase-section-title font-face-pop text-center">
                    { data && data.heading }
                </div>
                <div className="showcase-section-show">
                    <div className="row">
                        {
                            fakedb.nfts_top_8.map((item, index) => (
                                <div key={index} className="col-md-3 col-sm-6 showcase-card-wrapper">
                                    <Card06
                                        image={item.image}
                                        title={item.title}
                                    />
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NFTShowcaseSection
